import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';

type Props = {
  iconOnly?: boolean;
  onClick: () => void;
};

export const FilterButton = ({ iconOnly = false, onClick }: Props) => {
  const { t } = useTranslation('schedule');

  return (
    <Button variant='secondary' iconName='filter-alt' onClick={onClick}>
      {iconOnly ? ' ' : t('Filter')}
    </Button>
  );
};
